import React from 'react';
import { motion } from 'framer-motion';

export default function MatchStartSplash({ mode, logo, gameState }) {
  const displayMode = mode === 'donkey' ? 'Donkey' : mode === '56' ? '56 Mode' : mode === 'poker' ? 'Poker' : '28 Mode';

  let roundText = null;
  if (gameState) {
    const sprintRounds = gameState.sprint_rounds || 0;
    const currentRound = (gameState.total_rounds_played || 0) + 1;
    const isSuddenDeath = gameState.in_sudden_death;
    
    if (isSuddenDeath) {
      roundText = "SUDDEN DEATH (FINAL ROUND)";
    } else if (sprintRounds > 0 && currentRound === sprintRounds) {
      roundText = `ROUND ${currentRound} - FINAL ROUND!`;
    }
  }

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      style={{
        position: 'fixed',
        inset: 0,
        // Radial gradient matching your emerald green logo
        background: 'radial-gradient(circle, #062c1d 0%, #020617 100%)', 
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000,
      }}
    >
      <motion.div
        initial={{ scale: 0.5, opacity: 0, y: 20 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        transition={{ 
          duration: 0.8, 
          ease: [0, 0.71, 0.2, 1.01],
          scale: {
            type: "spring",
            damping: 12,
            stiffness: 100,
          }
        }}
        style={{ textAlign: 'center' }}
      >
        {/* The New Logo */}
        <img 
          src={logo} 
          alt="The Cheetu Club" 
          style={{ 
            width: '360px', /* Reduced from 450px for better balance */
            height: 'auto', 
            marginBottom: '40px', // Increased space below the logo
            filter: 'drop-shadow(0 0 20px rgba(0,0,0,0.5))' 
          }} 
        />

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <h1 style={{ 
            fontSize: '5rem', // Slightly larger for impact
            fontWeight: '900', 
            margin: '0', 
            color: '#facc15', // Gold accent
            textShadow: '0 4px 15px rgba(0,0,0,0.6)',
            lineHeight: 1
          }}>
            {displayMode}
          </h1>

          {roundText && (
            <h2 style={{
              fontSize: '2.5rem',
              fontWeight: '800',
              color: roundText.includes('FINAL') ? '#ef4444' : '#fff',
              marginTop: '15px',
              textShadow: '0 2px 10px rgba(0,0,0,0.5)'
            }}>
              {roundText}
            </h2>
          )}

          {/* ADDED GAP HERE */}
          <p style={{ 
            color: '#94a3b8', 
            letterSpacing: '0.3em', 
            textTransform: 'uppercase',
            fontSize: '0.9rem',
            marginTop: '30px', // Increased from -5px to 30px for breathing room
            fontWeight: '500'
          }}>
            © Vishnu Vijay
          </p>
        </motion.div>
      </motion.div>

      {/* Cinematic loading bar */}
      <motion.div 
        initial={{ width: 0 }}
        animate={{ width: '240px' }}
        transition={{ duration: 2.3, ease: "linear" }}
        style={{ 
          height: '2px', 
          backgroundColor: '#facc15', 
          marginTop: '60px',
          borderRadius: '1px',
          opacity: 0.4,
          boxShadow: '0 0 10px rgba(250, 204, 21, 0.3)'
        }}
      />
    </motion.div>
  );
}